import React, { Component } from 'react';
import './Home.css';

import { FILE } from '../../utils/constants/pdf';

const tempMidContainer = {
  background: '#fafafa',
  paddingBottom: '15px',
  width: '100%',
};

export default class Home extends Component {
  state = {
    files: [
      {
        name: '2026/2027 Region 20 Calendar',
        link: FILE.contestCalendar26,
      },
      {
        name: '2025/2026 Region 20 Calendar',
        link: FILE.calendar2526,
      },
      {
        name: '2026/2027 Contest Schedule',
        link: FILE.contestSchedule2027,
      },
      {
        name: '2025/2026 Judges List',
        link: FILE.judgesList,
      },
      { name: 'Region Guidelines and Policies', link: FILE.regionGuidelines },
      {
        name: '5/28/26 Executive Committee Meeting Minutes',
        link: FILE.committeeMinutes2026,
      },
      {
        name: '6/05/25 Executive Committee Meeting Minutes',
        link: FILE.execMinute2025,
      },
      {
        name: '5/23/24 Executive Committee Meeting Minutes',
        link: FILE.execMinutes2024,
      },
      {
        name: '10/17/24 Executive Committee Meeting Minutes',
        link: FILE.execMinutes,
      },
      { name: '2025/2026 Financial Report', link: FILE.financial_report_2026 },
      { name: '2024/2025 Financial Report', link: FILE.financial_report_2025 },
    ],
  };

  render() {
    const fileMap = this.state.files.map((e, i) => {
      return (
        <li key={i} className="band-link home-info">
          <a href={e.link} target="blank">
            {e.name}
          </a>
        </li>
      );
    });
    return (
      <div className="home_container">
        <div className="sub_home">
          <div className="home_img">
            <div className="region_logo_holder">
              <h1 style={{color: '#fff'}}>Region 20 Music</h1>
            </div>
          </div>
          <div className="body_container">
            <div className="rhombus" />
            <div className="school_listings">
              <h2>Welcome to Region 20</h2>
              <p>
                The collection of all school sponsored music events from Dallas
                ISD, DeSoto ISD, Duncanville ISD, Ennis ISD, Ferris ISD,
                Highland Park ISD, Irving ISD, Lancaster ISD, Red Oak ISD, RichardsonISD,
                and Waxahachie ISD.
              </p>
            </div>
            <div style={tempMidContainer}>
              <h2>
                All High School and Middle School events will be split up into
                North/South zones.
              </h2>
              <h4>Check the following links to see the divisions.</h4>
              <ul className="band-division-links">
                <li>
                  <a href={FILE.highSchoolDivisions} target="blank">
                    High School
                  </a>
                </li>
                <li>
                  <a href={FILE.middleSchoolDivisions} target="blank">
                    Middle School
                  </a>
                </li>
              </ul>
            </div>
            {/* <div style={tempMidContainer}>
              <h3>Fall Region Meeting</h3>
              <h4>
                Saturday, August 8, 2020
                <br />9 a.m. - 12 p.m.
              </h4>
              <p>
                Adamson High School
                <br />
                309 E 9th St, Dallas, TX 75203
              </p>
            </div> */}
            <div className="home_mid_container">
              <div className="home_mid mid_left">
                <img
                  className="home_icon"
                  src="https://image.flaticon.com/icons/svg/126/126486.svg"
                  alt=""
                />
                <div>
                  <h2>Executive Secretary</h2>
                  <h3 style={{ marginBottom: 0 }}>Scott Coulson</h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <a href={'mailto:uilmusicregion20@gmail.com'}>
                    <img
                      className="email_icon"
                      style={{ height: '15px', width: '15px', marginTop: '5px' }}
                      src="https://svgsilh.com/svg_v2/147563.svg"
                      alt={'EMAIL'}
                    />
                  </a>
                    <p>uilmusicregion20@gmail.com</p>
                  </div>

                  <pre style={{ marginTop: 0 }}>
                    {`4214 Ravenbank Dr.
Rockwall, Texas 75087
(214) 417 - 1042
uilmusicregion20@gmail.com
                    `}
                  </pre>
                </div>
              </div>
              <div className="home_mid mid_middle">
                <img
                  className="home_icon home_icon1"
                  src="https://image.flaticon.com/icons/svg/76/76694.svg"
                  alt=""
                />
                <div>
                  <h2>Upcoming</h2>
                  <div>
                    <h3>UIL Region 20 Executive Committee Meeting</h3>
                    <pre>
                      {`Thursday, October 15, 2026
via Electronic Communication
                    `}
                      {/* <ul className="home-page-meeting-ul">
                        <li className="band-link home-info">
                          <a href={FILE.committeeAgenda2026} target="blank">
                            Executive Meeting Agenda
                          </a>
                        </li>
                      </ul> */}
                    </pre>
                  </div>
                </div>
              </div>
              <div className="home_mid mid_right">
                <img
                  className="home_icon"
                  src="https://image.flaticon.com/icons/svg/820/820201.svg"
                  alt=""
                />
                <div style={{ maxWidth: '300px' }}>
                  <h2>Information</h2>
                  <ul>{fileMap}</ul>
                  {/* <p style={{ fontWeight: '800' }}>
                    **The 6A Region Marching Contest has been moved to
                    Wednesday, October 16. Performance times will remain the
                    same as posted.
                  </p> */}
                </div>
              </div>
            </div>
            <div className="home_mid_cont"></div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Home/Home.js